// Every route of the property-owner area. Use these instead of hardcoded strings
// so the area can move without breaking links.
export const PROPERTY_BASE = '/dashboard/property';

export const propertyPaths = {
  dashboard: PROPERTY_BASE,
  view: `${PROPERTY_BASE}/view`,
  add: `${PROPERTY_BASE}/add`,
  details: (id) => `${PROPERTY_BASE}/details/${id}`,
};
